import request from "services/Request"
import { serializeVoices, serializeVoice } from "types/Voice"

export function getMusics(params) {
	return request({
		url: `/shop/musics`,
		method: 'GET',
		params
	}, serializeVoices)
}

export function getMusicByUrl(url: string) {
	return request({
		url: url.startsWith('/api/v2/shop/products/') ?
            url.replace('/api/v2/shop/products', '/shop/musics') :
            url.replace('/api/v2', ''),
		method: 'GET'
	}, serializeVoice)
}

export function getMusicByCode(code: string) {
	return request({
		url: `/shop/musics/${code}`,
		method: 'GET'
	}, serializeVoice)
}
